import { LandingPageTypeEnum } from "@dev/ee-api/ee-api-models";

export const columnsWidth = {
    preview: '84px',
    view: '70px',
};

export const defaultParams = {
    type: LandingPageTypeEnum.DefaultLanding,
    offset: 0,
    limit: 3,
};
